/**
 * Indica se um documento e um CNPJ (Pessoa Juridica).
 *
 * Considera apenas os digitos: documentos com mais de 11 digitos sao CNPJ (14),
 * enquanto CPF possui 11.
 *
 * @param document CPF ou CNPJ, com ou sem mascara.
 */
export function isCnpj(document: string | number | null | undefined): boolean {
    return String(document || '').replace(/\D/g, '').length > 11;
}
